import React, { useState } from "react";

import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";

import FloatLabel from "./FloatingLabel";

import "./style.scss";

const Input = ({ placeholder, type, icon, ...rest }) => {
  const [inputTpe, setType] = useState(type);
  return (
    <FloatLabel
      className="container--input"
      label={placeholder}
      labelLeft={!isEmpty(icon) ? "label--left" : ""}
      {...rest}
      type={type}
      setType={setType}>
      {!isEmpty(icon) ? (
        <>
          <div className={"container--input--icon"}>{icon}</div>
          <input
            className={`container--input--inputItem ${
              rest.disabled && "disabled-input"
            }`}
            type={inputTpe}
            {...rest}
          />
        </>
      ) : (
        <input
          className={`input ${rest.disabled && "disabled-input"}`}
          type={inputTpe}
          {...rest}
        />
      )}
    </FloatLabel>
  );
};

Input.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.node,
};

Input.defaultProps = {
  placeholder: "",
};

export default Input;
